import React from "react";
import { Input, Row, Typography, Form, Card, Col } from "antd";
import appLabel from "../../../../../config/appLabel";
import { BOM } from "../../../../../services/definedMethod";
import { Tooltip } from "antd/lib";

const { Text } = Typography;

export default function TermsForm({ casaDetail }) {
  const [useForm] = Form.useForm();

  console.log(casaDetail);

  return (
    <Form layout="vertical" form={useForm}>
      <Card
        style={{
          marginBottom: "2%",
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          padding: 10,
        }}
      >
        <Row>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<Text strong>{appLabel.minimumOpeningBalance}</Text>}
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={casaDetail.minRequiredOpeningBalance}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text strong>{appLabel.lockInPeriod}</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={`${
                  casaDetail?.lockinPeriodFrequency
                    ? casaDetail?.lockinPeriodFrequency
                    : " "
                } ${
                  casaDetail.lockinPeriodFrequencyType
                    ? casaDetail.lockinPeriodFrequencyType.value
                    : "-"
                }`}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Text strong>{appLabel.applyWithdrawalFeeForTransfers}</Text>
              }
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={
                  casaDetail?.withdrawalFeeForTransfers === false ? "No" : "Yes"
                }
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text strong>{appLabel.allowOverdraft}</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={casaDetail?.allowOverdraft === true ? "Yes" : "No"}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text strong>{appLabel.maxOverdraftLimit}</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={casaDetail?.overdraftLimit}
              />
            </Form.Item>
          </Col>

          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Text strong>{appLabel.nominalAnnualInterestForOverdraft}</Text>
              }
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={casaDetail?.nominalAnnualInterestRateOverdraft}
              />
            </Form.Item>
          </Col>

          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Text strong>
                  <span>
                    <Tooltip
                      title={
                        appLabel.minOverdraftRequiredForInterestCalculation
                      }
                    >
                      {BOM.SubstringFormat(
                        appLabel.minOverdraftRequiredForInterestCalculation,
                        20
                      )}
                    </Tooltip>
                  </span>
                </Text>
              }
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={casaDetail?.minOverdraftForInterestCalculation}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Text strong>
                  <span>{appLabel.allowLien}</span>
                </Text>
              }
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={casaDetail?.lienAllowed ? "Yes" : "No"}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Text strong>
                  {appLabel.balanceRequiredForInterestCalculation}
                </Text>
              }
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={casaDetail.minBalanceForInterestCalculation}
              />
            </Form.Item>
          </Col>

          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<Text strong>{appLabel.enforceMinimumBalance}</Text>}
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={
                  casaDetail?.enforceMinRequiredBalance === false ? "No" : "Yes"
                }
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text strong>{appLabel.minimumBalance}</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={casaDetail.minRequiredBalance}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<Text strong>{appLabel.iswithholdTaxApplicable}</Text>}
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={casaDetail?.withHoldTax === false ? "No" : "Yes"}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<Text strong>{appLabel.iswithholdTaxApplicable}</Text>}
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={
                  casaDetail?.taxGroup?.name ? casaDetail?.taxGroup?.name : "-"
                }
              />
            </Form.Item>
          </Col>

          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<Text strong>{appLabel.isDormancyTrackingActive}</Text>}
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={
                  casaDetail?.isDormancyTrackingActive === false ? "No" : "Yes"
                }
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Text strong>{appLabel.numberOfDaysToInactiveSubStatus}</Text>
              }
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={casaDetail?.daysToInactive}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Text strong>{appLabel.numberOfDaysToDormantSubStatus}</Text>
              }
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={casaDetail?.daysToDormancy}
              />
            </Form.Item>
          </Col>

          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<Text strong>{appLabel.numberOfDaysToEscheat}</Text>}
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={casaDetail?.daysToEscheat}
              />
            </Form.Item>
          </Col>

          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<Text strong>{"Forfeit Interest for Withdrawals"}</Text>}
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={casaDetail?.forfeitInterest === false ? "No" : "Yes"}
              />
            </Form.Item>
          </Col>
          {casaDetail?.forfeitInterest && (
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text strong>{"Number of Withdrawals Threshold"}</Text>}
              >
                <Input
                  className="of-bold-disable-input"
                  disabled
                  value={casaDetail?.maxAllowedWithdrawalCount}
                />
              </Form.Item>
            </Col>
          )}
          <div style={{ width: "30vh" }}></div>
          <div style={{ width: "30vh" }}></div>
        </Row>
      </Card>
    </Form>
  );
}
